<ion-card
  class="horizontal-margin-5 parking-space-list__mobile-container high-z-index"
>
  <ion-card-header class="flex-direction-column">
    <ion-card-title
      class="space-date-filter__header"
      *ngIf="!p.renderMobile; else mobileHeader"
    >
      {{ options.headerDesktop }}
    </ion-card-title>
    <ng-template #mobileHeader>
      <ion-card-title
        class="space-date-filter__header space-date-filter__header--mobile"
      >
        {{
          options.headerMobile ? options.headerMobile : options.headerDesktop
        }}
      </ion-card-title>
    </ng-template>

    <form [formGroup]="form">
      <ion-row
        *ngIf="options.spaceType == 2"
        class="space-date-filter__input-outher-container"
      >
        <ion-col class="space-date-filter__date-input-container">
      <!-- INPUTY Z MOŻLIWOŚCIĄ WYBORU RÓŻNYCH DNI POCZĄTKU I KOŃCA REZERWACJI -->
          <div
            *ngIf="hasNoLimitBeforeRole"
            class="space-date-filter__date-input space-date-filter__date-input--first margin"
          >
          <!-- rezerwacja dla admina -->
            <ion-label>{{ "SPACE.RESERVATION_START" | translate }}</ion-label>
            <app-date-time-picker
              (afterPickerClosed)="dateTimeChange($event, true)"
              [value]="dateFrom"
            ></app-date-time-picker>
          </div>
          <div
            *ngIf="!hasNoLimitBeforeRole"
            class="space-date-filter__date-input space-date-filter__date-input--first margin"
          >
            <!-- rezerwacja z ograniczeniem -->
            <ion-label>{{ "SPACE.RESERVATION_START" | translate }}</ion-label>
            <div class="width__row">
              <div [ngClass]="(!hasDayLimitBeforeRole && p.renderMobile) ? 'width__70' : 'w-100' ">
                <app-date-time-picker
                  (afterPickerClosed)="dateTimeChange($event, true)"
                  [value]="dateFrom"
                  [max]="onlimitTimeBeforeReservation()"
                  [timerMax]="limitTimerBeforeReservation"
                  [disabled]="(spaceDateFilterService.setTimeToReservation && p.renderMobile)"
                ></app-date-time-picker>
              </div>
              <div 
                *ngIf="!hasDayLimitBeforeRole" 
                class="width__display width__30"
              >
                <ion-button 
                  class="picker-button space-date-filter__change-button width__height-42"
                  (click)="chooseTimeForHowLongNeedParking(true, false)"
                  *ngIf="p.renderMobile"
                >
                  {{ "CHANGE" | translate }}
                </ion-button>
              </div>
            </div>
          </div>

          <!-- rezerwacja dla admina -->
          <div 
            *ngIf="hasNoLimitBeforeRole"
            class="space-date-filter__date-input"
          >
            <ion-label>{{ "SPACE.RESERVATION_END" | translate }}</ion-label>
            <app-date-time-picker
              [min]="filterDetails.startDate"
              [max]="maxDate"
              (afterPickerClosed)="dateTimeChange($event, false)"
              [value]="dateTo"
            ></app-date-time-picker>
          </div>

          <!-- rezerwacja z ograniczeniem -->
          <div *ngIf="!hasNoLimitBeforeRole" class="space-date-filter__date-input">
            <ion-label>{{ "SPACE.RESERVATION_END" | translate }}</ion-label>
            <div class="width__row">
              <div [ngClass]="(!hasDayLimitBeforeRole && p.renderMobile) ? 'width__70' : 'w-100' ">
                <app-date-time-picker
                  [min]="filterDetails.startDate"
                  [max]="maxDate"
                  [timerMax]="limitTimer"
                  (afterPickerClosed)="dateTimeChange($event, false)"
                  [value]="dateTo"
                  [disabled]="(spaceDateFilterService.setTimeToReservation && p.renderMobile)"
                ></app-date-time-picker>
              </div>
              <div 
                *ngIf="!hasDayLimitBeforeRole" 
                class="width__display width__30"
              >
                <ion-button 
                  class="picker-button space-date-filter__change-button width__height-42"
                  (click)="chooseTimeForHowLongNeedParking(false, true)"
                  *ngIf="p.renderMobile"
                >
                  {{ "CHANGE" | translate }}
                </ion-button>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <!-- INPUTY Z MOŻLIWOŚCIĄ WYBORU REZERWACJI TYLKO NA JEDEN DZIEŃ-->
      <ion-row
        *ngIf="options.spaceType !== 2"
        class="space-date-filter__input-outher-container"
      >
        <ion-col class="space-date-filter__date-input-container">
          <div
            class="space-date-filter__date-input space-date-filter__date-input--full-width"
          >
            <ion-label> {{ "DAY" | translate }}</ion-label>
            <app-date-time-picker
              pickerType="calendar"
              (afterPickerClosed)="dateTimeChange($event, true, false)"
              [value]="dateFrom"
              placeholder="{{ 'ADDINVITATION.SELECTDATE' | translate }}"
            ></app-date-time-picker>
          </div>
        </ion-col>
      </ion-row>

      <ion-row
        *ngIf="options.spaceType !== 2"
        class="space-date-filter__input-outher-container"
      >
        <ion-col class="space-date-filter__date-input-container">
          <div
            class="space-date-filter__date-input space-date-filter__date-input--first"
          >
            <ion-label
              >{{ "ADD_INVITATION.START_TIME" | translate }}
            </ion-label>
            <app-date-time-picker
              (afterPickerClosed)="dateTimeChange($event, true, true)"
              pickerType="timer"
              [value]="dateFrom"
              placeholder="{{ 'ADD_INVITATION.SELECT_TIME' | translate }}"
            ></app-date-time-picker>
          </div>
          <div class="space-date-filter__date-input">
            <ion-label>{{ "ADD_INVITATION.END_TIME" | translate }}</ion-label>
            <app-date-time-picker
              pickerType="timer"
              (afterPickerClosed)="dateTimeChange($event, false, true)"
              [value]="dateTo"
              placeholder="{{ 'ADD_INVITATION.SELECT_TIME' | translate }}"
            ></app-date-time-picker>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-label
            *ngIf="
              (form.hasError('startDateBigger') ||
                form.hasError('sameDates')) &&
              (form.get('dateFrom').touched ||
                form.get('dateTo').touched ||
                validationError)
            "
            color="danger"
            class="font-size__16"
          >
            {{ "SPACE.DATE_ERROR" | translate }}
          </ion-label>
        </ion-col>
      </ion-row>

      <ion-row class="space-date-filter__input-outher-container ion-margin-top">
        <ion-col size="12" class="ion-no-padding">
          <ion-button
            (click)="showFilter()"
            expand="block"
            fill="outline"
            shape="round"
            class="space-date-filter__advanced-filter-button"
          >
            <ion-icon
              slot="start"
              src="../../../../../assets/icons/filter.svg"
            ></ion-icon>
            {{ "SPACE.ADVANCED_FILTER" | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    
      <ion-row class="space-date-filter__input-outher-container">
        <ion-col
          *ngIf="reservationForAnotherRole"
          size="12"
          class="ion-no-padding ion-margin-top display-flex flex-direction-column"
        >
          <ion-label>{{ "SPACE.ADD_RESERVATION_FOR" | translate }}:</ion-label>

          <app-select-buttons
            *ngIf="showOptionsButton"
            [keyValueList]="filterButtons"
            (selectedChange)="onFilterGuestType($event)"
            [selectedValue]="filterButtons[0].value"
            [defaultSelectedValue]="filterButtons[0].value"
            [disableDeselect]="true"
            [resetButtons]="resetButtonsSubject.asObservable()"
          >
          </app-select-buttons>
        </ion-col>
        <ion-col size="12" class="ion-no-padding">
          <app-select-user
            *ngIf="spaceDateFilterService.filterType == 'user'"
            (changeValueEvent)="onUserSelected($event)"
          ></app-select-user>

          <app-input *ngIf="spaceDateFilterService.filterType == 'guest'"
            type="input"
            [form]="form"
            formControlName="guest"
            [(ngModel)]="spaceDateFilterService.firstNameLastName"
            (ionChange)="checkGuest()"
            label="SPACE.FIRST_NAME_LAST_NAME"
            placeholder="{{ 'ADD_INVITATION.GUEST_REQUIRED' | translate }}"
            [submittedError]="validationError"
          ></app-input>
        </ion-col>
        <ion-col size="12" class="ion-no-padding" *ngIf="options.spaceType !== 3">
          <div class="control-display">
            <ion-button
            class="space-date-filter__advanced-filter-button" 
            expand="block"
            fill="outline"
            shape="round" 
            (click)="showCarPlate = !showCarPlate">
              <span *ngIf="options.spaceType == 2">
                {{ "SPACE.PARKING.PLATE_NUMBER" | translate }}
              </span>
              <ion-label *ngIf="options.spaceType == 1">
                {{ "BOOKING.TOPIC" | translate }}
              </ion-label>
              <ion-icon
                slot="end"
                name="chevron-down"
                [@toggleRotate]="showCarPlate ? 'active' : 'inactive'"
              ></ion-icon>
            </ion-button>
          </div>
          <app-input 
            *ngIf="showCarPlate"
            type="input"
            [form]="form"
            formControlName="carPlate"
            [setNgClass]="{
              'isDisabled': 
              ((!spaceDateFilterService.guestSelected) && (spaceDateFilterService.filterType == 'user') || 
              ((spaceDateFilterService.filterType == 'guest') && (!spaceDateFilterService.guestSelected))),
              'padding--start' : true
            }" 
            [disabled]="(
              (!spaceDateFilterService.guestSelected) && (spaceDateFilterService.filterType == 'user')) || 
              ((spaceDateFilterService.filterType == 'guest') && (!spaceDateFilterService.guestSelected)
            )"
            placeholder="{{
              ((!spaceDateFilterService.guestSelected) && (spaceDateFilterService.filterType == 'user')) || 
              ((spaceDateFilterService.filterType == 'guest') && (!spaceDateFilterService.guestSelected)) 
              ? label 
              : ' ' 
            }}"
            [submittedError]="validationError"
          ></app-input>
        </ion-col>
      </ion-row>
    </form>
    <ion-row class="space-date-filter__input-outher-container ion-margin-top">
      <ion-col size="12" class="ion-no-padding">
        <ion-button
          (click)="emitChange()"
          expand="block"
          [disabled]="
            ( spaceDateFilterService.filterType == 'user' || spaceDateFilterService.filterType == 'guest' ) && !spaceDateFilterService.guestSelected
          "
        >
          <ng-container
            *ngIf="spaceDateFilterService.filterType != 'user' || spaceDateFilterService.guestSelected"
          >
            {{ options.searchButtonText | translate }}
          </ng-container>
          <ng-container
            *ngIf="
              spaceDateFilterService.filterType == 'user' && !spaceDateFilterService.guestSelected
            "
          >
            {{ "SET_USER_FIRST" | translate }}
          </ng-container>
          <ng-container *ngIf="spaceDateFilterService.filtering">
            <img src="./assets/loading.svg" class="space-date-filter__loader" />
          </ng-container>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-card-header>
</ion-card>
